import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Filtering } from '../../../../service/filtering/filtering';
import { FormType } from '../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { BaseView } from '../../../base-view';
import { StorageManager } from '../../../../common/storage-manager.class';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import html2canvas from 'html2canvas';
import moment from 'moment';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';

import type { OnInit, AfterViewInit } from '@angular/core';
import { TareaOtraModel } from 'src/app/models/tareas/tarea-otra.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { environment } from '../../../../../environments/environment';
import { OtrasFormDefinition } from './otros-form/form-control/form-definition';

@Component({
    selector: 'app-otros',
    standalone: false,
    templateUrl: './otros.component.html',
    styleUrls: ['./otros.component.scss']
})
export class OtrosComponent extends BaseView<TareaOtraModel> implements OnInit, AfterViewInit {
    public years = [
        { label: '...', value: 0 },
    ];

    public aplicado = {
        selected: ''
    };

    public showTareasGenericasObservaciones = environment.features.showTareasGenericasObservaciones;

    public showParcelas = environment.features.showParcelas;


    public readonly selectedYearsControl = new FormControl<number>(0, { nonNullable: true });

    public modalShowCampaign = false;

    public canAddTareas = environment.features.canAddTareas;

    public showCampaign = environment.features.showTareasOtrasCampaign;

    public btnAnadir = 'Añadir Tarea';

    public appName = environment.appName;

    public applicationType = environment.features.applicationType;

    public rolUser = StorageManager.getUser().rol;

    public canDuplicateTareas = environment.features.canDuplicateTareas;

    public showRecetaPascualCabedo = environment.features.showRecetaPascualCabedo;

    public showRecetaAgrogest = environment.features.showRecetaAgrogest;

    public showEnviarCorreo = environment.features.showEnviarCorreo;

    public fincaName = environment.features.fincaName;

    public fincasName = environment.features.fincasName;

    public sectorName = environment.features.sectorName;

    public parcelaName = environment.features.parcelaName;

    public showTareasOtrosDuracion = environment.features.showTareasOtrosDuracion;

    public showTareasOtrasProducto = environment.features.showTareasOtrasProducto;

    public showTareasOtrasCantidad = environment.features.showTareasOtrasCantidad;

    public showTareasProcura = environment.features.showTareasProcura;

    public serveUrl = environment.serverUrl;

    public changeLabelProducto = false;

    public showTareasOtrosImagen = environment.features.showTareasOtrosImagen;

    public betweenDates = environment.features.betweenDatesGenericas;

    public timeStartStopTareas = environment.features.timeStartStopTareas;

    public showPrescripcion = false;

    public receta: TareaOtraModel = {};

    public showReceta = false;

    public getRequest!: RequestHandler<TareaOtraModel[]>;

    public deleteRequest!: RequestHandler<TareaOtraModel>;

    public form: OtrasFormDefinition | null = null;

    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;

    public prioridad = {
        selected: ''
    };


    public cols: ColInterface[] = [
        { 
            field: 'fecha', 
            header: 'Fecha', 
            filter: ''
        },
        { 
            field: 'finca', 
            header: this.fincaName, 
            filter: '',            
            visible: this.appName !== 'detorres',
        },
        { 
            field: 'sector', 
            header: this.sectorName, 
            filter: '',
            visible: environment.features.showSectores
        },
        { 
            field: 'parcelas', 
            header: this.parcelaName, 
            filter: '' ,
            visible: this.showParcelas
        },
        { 
            field: 'tarea', 
            header: (this.esViveroOGardenGest() && this.appName !== 'detorres') ? 'Genérica' : 'Tarea',
            filter: '' 
        },
        { 
            field: 'duracion', 
            header: 'Duración',
            filter: '',
            visible: this.showTareasOtrosDuracion && !environment.features.tareasHorasTotales 
        },
        { 
            field: 'producto', 
            header: 'Productos',
            visible: this.showTareasOtrasProducto, 
            filter: '' 
        },
        { 
            field: 'cantidad', 
            header: 'Cantidad',            
            visible: this.showTareasOtrasCantidad, 
            filter: '' 
        },
        { 
            field: 'trabajadores_nombre', 
            header: 'Trabajadores', 
            filter: '',
            visible: (this.appName === 'tomega' && this.rolUser !== 'aplicador') || this.appName !== 'tomega'
        },
        { 
            field: 'maquinaria', 
            header: 'Maquinaria', 
            filter: '' ,
            visible: this.appName !== 'detorres'
        },
        { 
            field: 'hora_inicio', 
            header: 'Hora Inicio',
            visible: environment.features.tareasHorasTotales, 
            filter: '' 
        },
        { 
            field: 'hora_fin', 
            header: 'Hora Fin',
            visible: environment.features.tareasHorasTotales, 
            filter: '' 
        },
        { 
            field: 'horas_totales', 
            header: 'Horas Totales',
            visible: environment.features.tareasHorasTotales, 
            filter: '' 
        },
        { 
            field: 'aplicado', 
            header: 'Aplicado',
            visible: this.appName === 'ava', 
            filter: '' 
        },
        { 
            field: 'nombres_asignados', 
            header: 'Asignador', 
            filter: '',
            visible: environment.features.showAssignUserTasksFitosanitario || environment.features.showAssignUserInAllTasks 
        },
        {
            field: 'prioridad', 
            header: 'Prioridad/Realizada', 
            filter: '',
            visible: environment.features.showTareasMto 
        },
        {
            field: 'tareas_maquinaria',
            header: 'Tareas Maquinaria',
            filter: '',
            visible: environment.features.activateSIEX
        },
        {
            field: 'tareas_manuales',
            header: 'Tareas Manuales',
            filter: '',
            visible: environment.features.activateSIEX
        },
        {
            field: 'actividad_agraria',
            header: 'Actividad Agraria',
            filter: '',
            visible: environment.features.activateSIEX
        },

    ];

    public fecha: { inicio: string; fin: string } = {
        inicio: '',
        fin: '',
    };

    public filter: Filtering<TareaOtraModel> = new Filtering<TareaOtraModel>();

    public imagenAdjunto = '';

    totalHoras: moment.Moment | string = '';

    auxTotalHoras: moment.Moment | string = '';

    optionsSelectButton = [
        { label: 'Todos', value: 0 },
        { label: 'Si', value: 1 },
        { label: 'No', value: 2 },
    ];

    public readonly realizadoControl = new FormControl<number>(0, { nonNullable: true });


    constructor(public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        private readonly router: Router) {
        super(
            dashboardEvents,
            tareasApi.otras.GET,
            tareasApi.otras.DELETE
        );

        this.getRequest = tareasApi.otras.GET;
        this.deleteRequest = tareasApi.otras.DELETE;
    }

    ngAfterViewInit(): void {
        if (this.showCampaign) {

            this.fillCampaign();
            this.filter.addFilter((copy: TreeNode<TareaOtraModel>[] | void) => (copy as TreeNode<TareaOtraModel>[]).filter(row => {

                if (this.selectedYearsControl.value === 0) {
                    return true;
                } else {
                    return this.compareDates(row);
                }
            }));
        }
        this.tareasApi.otras.GET.response(() => {
            this.updateFooter();
        });
    }

    ngOnInit() {

        this.dashboardEvents.setSubmenuItem('tareas', 'tareas-otros');
        if (this.showRecetaAgrogest) {
            this.showPrescripcion = true;
        }

        if(environment.appName === 'ava' || environment.appName === 'detorres'){

            this.filter.addFilter((copy: TreeNode<TareaOtraModel>[] | void) => 
                (copy as TreeNode<TareaOtraModel>[]).filter(row => {
                    const tareaOtra = row as TareaOtraModel;
            
                    switch (this.realizadoControl.value) {
                    case 1:
                        return ['Realizada'].includes(tareaOtra.prioridad ?? '');
                    case 2:
                        return !['Realizada'].includes(tareaOtra.prioridad ?? '');
                    default:
                        return true;
                    }
                }));
                
            this.filter.addFilter((copy: TreeNode<TareaOtraModel>[] | void) => (copy as TreeNode<TareaOtraModel>[]).filter(row => {
                const tareaOtra = row as TareaOtraModel;
    
                if (this.fecha.inicio && this.fecha.fin) {
                    if (tareaOtra.fecha == null) {
                        return false;
                    } else {
                        const arrayFecha = tareaOtra.fecha.split('/');
                        const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];
    
                        if (
                            (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                            (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    }
    
                } else {
                    return true;
                }
            }));
        }


        /**
             *  Activado la asignacion de usuarios en la tabla tareas
             *  Filtraremos las tareas si en caso de que el usuario se encuentre como asignado en la tarea
             */
        // if (environment.features.showAssignUserTasksFitosanitario || environment.features.showAssignUserInAllTasks) {
        if (this.appName === 'ava') {
            /** Solo el que tiene el rol de admin podra ver todas las tareas */
            if (StorageManager.getUser().rol !== 'admin') {
                this.filter.addFilter((copy: TreeNode<TareaOtraModel>[] | void) => (copy as TreeNode<TareaOtraModel>[]).filter(row => {
                    const tareaOtra = row as TareaOtraModel;

                    if (tareaOtra.referencia_usuario != null) {

                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaOtra.referencia_usuario as string)?.split(';');

                        if (listaTrabajadores?.includes(idTrabajador)) {
                            return true;
                        }
                    }
                    return false;
                }));
            }
        }// Fin filtro asignados

        if (this.appName === 'tomega') {
            /** Solo el que tiene el rol de admin podra ver todas las tareas */
            if (StorageManager.getUser().rol !== 'admin') {
                this.filter.addFilter((copy: TreeNode<TareaOtraModel>[] | void) => (copy as TreeNode<TareaOtraModel>[]).filter(row => {
                    const tareaOtra = row as TareaOtraModel;

                    const idTrabajador = StorageManager.getUser().id_trabajador;
                    const listaTrabajadores = (tareaOtra.ids_trabajadores as string)?.split(';');
                    
                    return listaTrabajadores?.includes(idTrabajador?.toString() ?? '');
                }));
            }
        }// Fin filtro asignados
    }


    public override show(modal: string, data: TareaOtraModel): void {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new OtrasFormDefinition([], [], formType, data);
        this.getVisitImages();
    }

    public override hide(modal: string): void {
        super.hide(modal);
        this.form = null;
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<TareaOtraModel>) {
        const tareaOtra = row.data as TareaOtraModel;
        
        if (col.field === 'parcelas') {
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'duracion') {
            const fin = moment(tareaOtra.hora_fin, 'HH:mm');
            const inicio = moment(tareaOtra.hora_inicio, 'HH:mm');

            if (!inicio.isValid() || !fin.isValid()) {
                return '';
            }

            const duracion = fin.subtract(inicio.get('hours'), 'hours').subtract(inicio.get('minutes'), 'minutes').format('HH:mm');

            return duracion;
        }
        return value;
    }

    public esViveroOGardenGest() {
        if (this.serveUrl.includes('gardengest') || this.serveUrl.includes('viverogest')) {
            return true;
        } else {
            return false;
        }
    }

    public add() {
        this.router.navigate(['dashboard', 'tareas-crear-otra']);
    }

    public edit(data: TareaOtraModel) {
        this.router.navigate(['dashboard', 'tareas-editar-otra', data.id]);
    }

    public duplicate(data: TareaOtraModel) {
        this.router.navigate(['dashboard', 'tareas-duplicar-otra', data.id]);
    }

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public generarReceta(data: TareaOtraModel) {
        this.receta = data;
        this.showReceta = true;
    }

    public enviarCorreo() {
        html2canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement(), { scale: 2 }).then((canvas: HTMLCanvasElement) => {
            const adjunto = canvas.toDataURL('image/png');
            let email = '';

            if (this.receta.finca_email) {
                email = this.receta.finca_email;
            } else if (this.receta.cliente_email) {
                email = this.receta.cliente_email;
            } else {
                email = '';
            }
            if (email !== '') {
                this.tareasApi.enviarRecetaCaptura.perform({
                    email,
                    generado: adjunto,
                    finca: this.receta.finca_asociada,
                    tratamiento: this.receta.tratamiento_nombre,
                } as never);
            } else {
                this.tareasApi.enviarRecetaCaptura.hasError = true;
                this.tareasApi.enviarReceta['error'] = 'El cliente o finca no tiene un email asociado';
            }
            return;
        }).catch((e: unknown) => {
            console.log('catch en getPosition: ' + e);
        }
        ).then(() => {
            console.log('Adjuntos generados.');
            return;
        }, (error: unknown) => {
            console.log(error);
            this.tareasApi.enviarRecetaCaptura.hasError = true;
            this.tareasApi.enviarReceta['error'] = 'Error al envíar email';
            return;
        }).catch((e: unknown) => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }

    public imprimirReceta() {
        html2canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement(), { scale: 2 }).then((canvas: HTMLCanvasElement) => {
            const downloadReceta = document.getElementById('downloadReceta') as HTMLAnchorElement;

            downloadReceta.href = canvas.toDataURL('image/png');
            downloadReceta.download =
                (this.receta.cliente_nombre || '.').replace('.', '')
                + ' - ' +
                (this.receta.finca || '.').replace('.', '');
            downloadReceta.click();
            return;
        }).catch((e: unknown) => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }

    modalCampaign() {
        this.modalShowCampaign = true;
    }

    closeModalShowCampaign() {
        this.modalShowCampaign = false;
    }

    selectedCampaign() {
        this.filter.filter();
    }

    compareDates(row: TreeNode<TareaOtraModel>) {
        const tareaOtra = row as TareaOtraModel;

        if (tareaOtra.fecha == null || tareaOtra.fecha.length === 0) {
            return false;
        }

        const auxFecha = tareaOtra.fecha.split('/');
        const nuevaFecha = moment(auxFecha[2] + '-' + auxFecha[1] + '-' + auxFecha[0]);
        const selectedYears = this.selectedYearsControl.value;
        const fechaComparar = moment('20' + selectedYears.toString() + '-07' + '-01');
        const fechaMax = moment('20' + (selectedYears + 1).toString() + '-06' + '-30');

        if ((nuevaFecha > fechaComparar) && (nuevaFecha < fechaMax)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     *  Rellena el listado de campañas
     */
    fillCampaign() {
        const fechaActual = new Date().getFullYear();
        let fechaDosDigitos = 0;

        for (let index = 2020; index <= fechaActual; index++) {

            fechaDosDigitos = parseInt((index.toString()).substring(2, 4), 10);
            this.years.push({ 
                label: environment.features.applicationType === 'cropgest' ? 
                    index.toString() : (index.toString() + '-' + (fechaDosDigitos + 1 ).toString()), 
                value: fechaDosDigitos 
            });

        }
    }

    public getVisitImages() {

        if (this.model.adjunto) {
            fetch(environment.serverUrl + 'tareas_otros/' + (this.model.adjunto || {}))
                .then((r) => {
                    if (r.status === 200) {
                        this.imagenAdjunto = environment.serverUrl + 'tareas_otros/' + (this.model.adjunto || {});
                    }
                    return;
                }).catch((e: unknown) => {
                    console.log('catch en getPosition: ' + e);
                }
                );
        } else {
            this.imagenAdjunto = '';
        }
    }

    public verAdjunto() {
        if (this.model.adjunto) {
            const myWindow = window.open('about:blank', '_blank', 'width=600, height=600');

            myWindow?.location.assign(environment.serverUrl + 'tareas_otros/' + this.model.adjunto);
            myWindow?.focus();
        } else {
            alert('Esta máquina no tiene fotos.');
        }
    }

    public override sum() {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;

        (this.filter.value || []).forEach((tareas, index) => {

            if (tareas.data?.horas != null) {

                if (tareas.data.horas.length > 0) {
                    contador++;
                    const horaMinuto = (tareas.data.horas as string).split(':');

                    this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
                }
            }

            if (index + 1 >= (this.filter.value as TareaOtraModel[]).length) {

                let minutos = moment(this.totalHoras).format('mm');

                let differencia = moment(this.totalHoras).diff(this.auxTotalHoras);

                if (minutos.toString().length === 0) {
                    minutos = '00';
                }

                if (minutos.toString().length === 1) {
                    minutos = '0' + minutos.toString();
                }

                differencia = differencia / (1000 * 60 * 60);
                differencia = Math.abs(Math.floor(differencia));

                this.totalHoras = differencia + ':' + minutos;

                if (contador === 0) {
                    this.totalHoras = '00:00';
                }

            }


        });

        if (contador === 0) {
            this.totalHoras = '00:00';
        }
        this.filter.filter();
    }

    getFechaInicio(event: string) {
        this.fecha.inicio = event;
        this.filter.filter();
        this.updateFooter();
    }

    getFechaFin(event: string) {
        this.fecha.fin = event;
        this.filter.filter();
        this.updateFooter();
    }

    public override updateFooter() {
        this.sum();
    }

    public downloadCsv(): void {

        const form = new OtrasFormDefinition([], [], +FormType.EXPORT, {});
        const csvContent = createCsv(form.fieldNames, form.fieldLabels, this.filter.value as TareaOtraModel[]);

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = 'Tareas Genéricas.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    filtrar(): void {
        this.filter.filter();
        this.updateFooter();
    }

    public filtrarRealizados(value: string, from = 'prioridad') {
        if (from === 'aplicado') {
            this.aplicado.selected = this.aplicado.selected === value ? '' : value;
        }

        this.filter.filter();
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {

        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },  
                };
            }
            else if (value === 'Realizada'){
                return {
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },  
                };
            }
        }

        if (col.field === 'horas') {
            return {
                textAlign: 'center'
            };
        }

        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },
                };
            }
            else if (value === 'Realizada') {
                return {
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },
                };
            }
        }
        return {textAlign: 'center'};
    }
}
